import { createSlice } from "@reduxjs/toolkit";
import { getImports, updateRow, updateStatus } from "./thunk";
import { toast } from "react-toastify";
export const initialState = {
  imports: [],
  updatedRow: {},
  updatedStatus: null,
  error: {},
  loading: false,
  updatingStatus: false,
};

const AnalysisSlice = createSlice({
  name: "AnalysisSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getImports.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) state.imports = action.payload.data;
      else state.error = action.payload.message || null;
      state.loading = false;
    });

    builder.addCase(getImports.rejected, (state, action) => {
      // state.error = action.payload.error || null;
    });

    builder.addCase(getImports.pending, (state) => {
      toast.dismiss();
      toast.loading("Getting products...", {
        position: "top-center",
        autoClose: false,
      });
      state.loading = true;
      state.imports = [];
      state.error = {};
    });

    builder.addCase(updateRow.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Row...", {
        position: "top-center",
        autoClose: false,
      });
      state.updatedRow = {};
      state.updatedStatus = null;
      state.error = {};
    });

    builder.addCase(updateRow.fulfilled, (state, action) => {
      toast.dismiss();
      if (action.payload.success) {
        toast.success("Product updated Successfully", {
          position: "top-center",
          autoClose: 500,
        });
        state.updatedRow = action.payload.data;
        const index = state.imports.findIndex(
          (row) => row.imp_id === action.payload.data.imp_id
        );
        if (index !== -1) {
          state.imports[index] = {
            ...action.payload.data,
          };
        }
      } else state.error = action.payload.message || null;
    });

    builder.addCase(updateRow.rejected, (state, action) => {
      toast.dismiss();
      console.log("Error", action);
     // state.error = action.payload.error || null;
    });

    builder.addCase(updateStatus.pending, (state, action) => {
      toast.dismiss();
      toast.loading("Updating Status...", {
        position: "top-center",
        autoClose: false,
      });
      state.updatedStatus = null;
      state.error = {};
      state.updatingStatus = true;
    });

    builder.addCase(updateStatus.fulfilled, (state, action) => {
      toast.dismiss();
      state.updatingStatus = false;
      
      if (action.payload.success) {
        state.updatedStatus = action.payload.data;
      } else {
        state.error = action.payload.message || null;
        toast.error(action.payload.message || "Failed to update status", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    });

    builder.addCase(updateStatus.rejected, (state, action) => {
      toast.dismiss();
      state.updatingStatus = false;
      console.log("Error", action);
      toast.error("An error occurred while updating status", {
        position: "top-center",
        autoClose: 3000,
      });
      // state.error = action.payload.error || null;
    });
  },
});

export default AnalysisSlice.reducer;
